<template>
  <div>
    <vx-card>
      <table>
        <tr>
          <template v-if="!filterConfig.withoutDate">
            <td>
              <section>
                <p>{{ $t("startDate") }}</p>
                <DatePicker
                  size="small"
                  class="mr-3"
                  style="width: 200px"
                  :shortcuts="shortcuts"
                  :format="$formatDate"
                  :value="tglAwal"
                  type="date"
                  placeholder="Select date"
                  v-model="tglAwal"
                  @change="cekTanggal()"
                ></DatePicker>
              </section>
            </td>

            <td>
              <section>
                <p>{{ $t("endDate") }}</p>
                <DatePicker
                  size="small"
                  style="width: 200px"
                  :shortcuts="shortcuts"
                  :format="$formatDate"
                  :value="tglAkhir"
                  type="date"
                  placeholder="Select date"
                  v-model="tglAkhir"
                  @change="cekTanggal()"
                ></DatePicker>
              </section>
            </td>
          </template>

          <td class="ml-3">
            <el-checkbox class="ml-3" v-model="filterConfig.withoutDate">{{
              $t("cariTanpaTanggal")
            }}</el-checkbox>
          </td>
        </tr>
      </table>

      <el-tabs @tab-click="handleClickTab">
        <el-tab-pane :label="$t('requestList')">
          <el-row>
            <el-col :span="24">
              <vxe-toolbar>
                <template v-slot:buttons>
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="goApprove"
                    :disabled="isCheckPrint == true"
                    v-if="$store.state.isCreate"
                    >{{ $t("approveSelected") }}
                    {{ $t("data") }} (FIFO)</el-button
                  >
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="goApprove('manual')"
                    :disabled="isCheckPrint == true"
                    v-if="$store.state.isCreate"
                    >{{ $t("approveSelected") }} {{ $t("data") }} (MANUAL
                    EXBC)</el-button
                  >
                  <el-button
                    size="mini"
                    :disabled="isCheckPrint == true"
                    class="mx-3"
                    type="primary"
                    @click="exportExcel"
                    >Export Excel</el-button
                  >
                  <el-button size="mini" type="primary" @click="printOutCheck">
                    PRINT
                  </el-button>
                </template>
              </vxe-toolbar>
              <div style="height: 90vh">
                <vxe-table
                  size="mini"
                  :loading="loadingTable"
                  empty-text="Empty Data "
                  keep-source
                  border
                  show-overflow
                  show-header-overflow
                  ref="xTable"
                  height="90%"
                  row-key
                  highlight-hover-row
                  highlight-current-row
                  show-footer
                  :footer-method="footerMethod"
                  :row-config="{ isCurrent: true, isHover: true, height: 35 }"
                  :column-config="{ resizable: true }"
                  :data="dataBarangjadi"
                  :mouse-config="{ selected: true }"
                  :checkbox-config="{
                    highlight: true,
                    range: true,
                    checkMethod: checkMethod,
                  }"
                  :keyboard-config="{
                    isArrow: true,
                    isDel: true,
                    isEnter: true,
                    isTab: true,
                    isEdit: true,
                  }"
                  @cell-dblclick="handleCellClick"
                  :edit-config="{
                    trigger: 'dblclick',
                    mode: 'cell',
                    showStatus: true,
                  }"
                  :scroll-y="{ mode: 'wheel' }"
                  @filter-change="changeFilter"
                >
                  <vxe-column type="seq" fixed="left" width="60"></vxe-column>
                  <vxe-column
                    type="checkbox"
                    fixed="left"
                    width="60"
                  ></vxe-column>
                  <vxe-column
                    fixed="left"
                    width="150"
                    align="center"
                    sortable
                    field="approveStatus"
                    :title="$t('approveStatus').toUpperCase()"
                    header-align="center"
                  >
                    <template v-slot:default="{ row }">
                      <el-tag
                        size="mini"
                        type="success"
                        v-if="
                          row.isComplete ||
                          row.qtyOut.toFixed(4) >= row.qty.toFixed(4)
                        "
                        >{{ $t("terpenuhi") }}
                      </el-tag>
                      <el-tag
                        size="mini"
                        type="warning"
                        v-else-if="!row.isComplete && row.qtyOut > 0"
                        >{{ $t("separuhTerpenuhi") }}
                      </el-tag>
                      <el-tag
                        size="mini"
                        type="danger"
                        v-else-if="!row.isComplete && row.qtyOut <= 0"
                        >{{ $t("belumTerpenuhi") }}
                      </el-tag>
                    </template>
                  </vxe-column>

                  <vxe-column
                    align="align"
                    header-align="center"
                    width="150"
                    field="tglRequest"
                    :formatter="$$formatDate"
                    :title="$t('tanggal').toUpperCase()"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>
                  <vxe-column
                    align="align"
                    header-align="center"
                    width="350"
                    field="noReg"
                    :title="$t('noRegi').toUpperCase()"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>
                  <vxe-column
                    width="150"
                    align="center"
                    header-align="center"
                    field="department"
                    :title="$t('dept').toUpperCase()"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                    <template #default="{ row }">
                      <span>{{
                        row.department ? row.department.toUpperCase() : ""
                      }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column
                    width="100"
                    align="center"
                    header-align="center"
                    field="user"
                    :title="$t('user').toUpperCase()"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>
                  <vxe-column
                    width="100"
                    align="center"
                    header-align="center"
                    field="noWo"
                    :title="$t('noPO').toUpperCase()"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>

                  <vxe-column
                    width="180"
                    align="left"
                    header-align="center"
                    field="kodeMaterial"
                    :title="$t('code').toUpperCase()"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>
                  <vxe-column
                    width="250"
                    align="left"
                    header-align="center"
                    field="namaMaterial"
                    :title="$t('deskripsi').toUpperCase()"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>

                  <vxe-column
                    width="100"
                    align="center"
                    header-align="center"
                    field="satuan"
                    :title="$t('satuan').toUpperCase()"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>
                  <vxe-column
                    width="150"
                    align="right"
                    header-align="center"
                    field="qty"
                    :title="$t('qtyRequest').toUpperCase()"
                    :formatter="$$formatAmountBc"
                    sortable
                  >
                  </vxe-column>
                  <vxe-column
                    width="150"
                    align="right"
                    header-align="center"
                    field="qtyOut"
                    :formatter="$$formatAmountBc"
                    :title="$t('qtyOut').toUpperCase()"
                    sortable
                  >
                  </vxe-column>
                  <vxe-column
                    width="150"
                    align="right"
                    header-align="center"
                    field="sisaRequest"
                    :title="$t('sisaRequest').toUpperCase()"
                    :formatter="$$formatAmountBc"
                    sortable
                  >
                  </vxe-column>
                  <vxe-column
                    width="100"
                    align="center"
                    header-align="center"
                    field="style"
                    :title="$store.state.styleName"
                    v-if="$store.state.availableStyle"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>
                  <vxe-column
                    width="100"
                    align="center"
                    header-align="center"
                    field="color"
                    :title="$store.state.colorName"
                    v-if="$store.state.availableColor"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>
                  <vxe-column
                    width="100"
                    align="center"
                    header-align="center"
                    field="size"
                    :title="$store.state.sizeName"
                    v-if="$store.state.availableSize"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>
                  <vxe-column
                    width="100"
                    align="center"
                    header-align="center"
                    field="spec"
                    :title="$store.state.specName"
                    v-if="$store.state.availableSpec"
                    sortable
                    :filters="[{ data: '' }]"
                    :filter-method="$$filterHeaderTable"
                  >
                    <template #filter="{ $panel, column }">
                      <input
                        style="margin: 10px"
                        type="type"
                        v-for="(option, index) in column.filters"
                        :key="index"
                        v-model="option.data"
                        @input="
                          $panel.changeOption($event, !!option.data, option)
                        "
                      />
                    </template>
                  </vxe-column>
                  <CustomHead />
                </vxe-table>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <table>
        <tr>
          <td>
            <div v-if="tglKeluar !== '' && baca.length > 0">
              <vs-button
                v-if="save != true"
                icon-pack="feather"
                icon="icon-save"
                @click.prevent="submitedData"
                >{{ $t("simpanData") }}
              </vs-button>
            </div>
          </td>
        </tr>
      </table>
    </vx-card>

    <br />

    <vxe-modal
      v-model="modalApprove"
      :title="$t('approveSelectedRequest').toUpperCase()"
      width="90%"
      height="90%"
      show-zoom
      resize
    >
      <template #default>
        <el-row>
          <el-col :span="24">
            <vxe-toolbar>
              <template #buttons>
                <h3>{{ $t("listRequest") }}</h3>

                <el-popconfirm
                  v-if="manualExbc == false"
                  class="ml-3"
                  confirm-button-text="OK"
                  cancel-button-text="No, Thanks"
                  icon="el-icon-info"
                  icon-color="primary"
                  :title="$t('isDoThis').toUpperCase()"
                  @confirm="approveAllSelected"
                >
                  <el-button
                    class="ml-3"
                    slot="reference"
                    size="mini"
                    type="primary"
                    icon="el-icon-check"
                  >
                    {{ $t("approveAllReq") }}</el-button
                  >
                </el-popconfirm>
              </template>
              <template #tools>
                <div class="m-auto flex items-center gap-2 justify-center">
                  <label for="">Tanggal Keluar</label>
                  <DatePicker
                    @change="resetOut"
                    class="w-full"
                    :format="$formatDate"
                    type="date"
                    placeholder="Select date"
                    v-model="formDataOut.tglKeluar"
                  />
                  <el-checkbox
                    v-if="!manualExbc"
                    v-model="outByStyle"
                    @change="saveToLocalStorageOut"
                    >Out By Style</el-checkbox
                  >
                </div>
              </template>
            </vxe-toolbar>
            <el-divider />
            <TableFull
              @sendData="cariExbc"
              :tableConfig="tableConfigRequest"
              ref="tableRequest"
              :rowStyleFunction="rowStyleRequest"
            />
          </el-col>
        </el-row>
        <el-divider />
        <el-row>
          <el-col :span="24">
            <h3>{{ $t("dataOut") }}</h3>

            <TableFull :tableConfig="tableConfigOut" />
          </el-col>
        </el-row>

        <vxe-form title-align="right" title-width="60">
          <vxe-form-item align="center" span="24">
            <template #default>
              <el-button type="primary" @click="saveApprove">{{
                $t("saveConfirmApprove")
              }}</el-button>

              <el-button type="reset" @click="modalApprove = false">{{
                $t("close")
              }}</el-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </template>
    </vxe-modal>

    <sweet-modal ref="nestedChildBarang" width="80%" style="z-index: 10">
      <h3>Select Available Customs Document</h3>
      <vxe-toolbar>
        <template #buttons>
          <table>
            <tr>
              <td>
                <section>
                  <p>START DATE</p>
                  <DatePicker
                    size="small"
                    class="mr-3"
                    style="width: 200px; z-index: 20"
                    :shortcuts="shortcuts"
                    :format="$formatDate"
                    :value="tglAwalDoc"
                    type="date"
                    placeholder="Select date"
                    v-model="tglAwalDoc"
                    @change="cekTanggalDoc()"
                  ></DatePicker>
                </section>
              </td>

              <td>
                <section>
                  <p>END DATE</p>
                  <DatePicker
                    size="small"
                    style="width: 200px; z-index: 20"
                    :shortcuts="shortcuts"
                    :format="$formatDate"
                    :value="tglAkhirDoc"
                    type="date"
                    placeholder="Select date"
                    v-model="tglAkhirDoc"
                    @change="cekTanggalDoc()"
                  ></DatePicker>
                </section>
              </td>

              <td></td>
            </tr>
          </table>
        </template>
      </vxe-toolbar>
      <vxe-table
        size="mini"
        class="mt-5"
        :loading="loadingTable"
        empty-text="Empty Data "
        keep-source
        border
        show-overflow
        show-header-overflow
        ref="tableOut"
        height="220"
        row-key
        highlight-hover-row
        highlight-current-row
        :row-config="{ isCurrent: true, isHover: true, height: 35 }"
        :column-config="{ resizable: true }"
        :data="dataOut"
        :mouse-config="{ selected: true }"
        :checkbox-config="{
          highlight: true,
          range: true,
          // checkRowKeys: selectRow != null ? [] : checkDefault
        }"
        :keyboard-config="{
          isArrow: true,
          isDel: true,
          isEnter: true,
          isTab: true,
          isEdit: true,
        }"
        :edit-config="{
          trigger: 'dblclick',
          mode: 'cell',
          showStatus: true,
        }"
        :scroll-y="{ mode: 'wheel' }"
        @checkbox-all="selectOut"
        @checkbox-change="selectOut"
      >
        <vxe-column type="seq" fixed="left" width="60"></vxe-column>
        <vxe-column type="checkbox" width="60"></vxe-column>
        <vxe-column
          align="align"
          header-align="center"
          width="150"
          field="tglDokumen"
          :formatter="$$formatDate"
          title="BC DATE"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>
        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          align="align"
          header-align="center"
          width="150"
          field="idDokumen"
          title="BC DOC TYPE"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>
        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="100"
          align="center"
          header-align="center"
          field="noUrut"
          title="BC DOC NO"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>

        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="150"
          align="left"
          header-align="center"
          field="noLot"
          title="NO LOT"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>

        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="120"
          align="left"
          header-align="center"
          field="kodeBarang"
          title="CODE"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>
        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="200"
          align="left"
          header-align="center"
          field="namaBarang"
          title="DESCRIPTION"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>

        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="100"
          align="center"
          header-align="center"
          field="satuan"
          title="UNIT"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>

        <vxe-column
          width="150"
          align="right"
          header-align="center"
          field="balance"
          :formatter="$$formatAmountBc"
          title="SISA QTY"
        >
        </vxe-column>
      </vxe-table>
      <h5 class="mb-4 mt-4">
        {{
          selectRow != null
            ? `Select Dokumen For Material ${selectRow.kodeMaterial} - ${selectRow.namaMaterial} - ${selectRow.noWo}`
            : ""
        }}
      </h5>
      <div v-if="selectRow != null">
        <h5>Qty Yang di Butuhkan: {{ $formatAngka(selectRow.balance) }}</h5>
        <h5>
          Qty Yang Sudah di Keluarkan:
          {{ totalKeluar }}
        </h5>
      </div>

      <vxe-table
        size="mini"
        v-if="selectRow != null"
        class="mt-3"
        :loading="loadingTable"
        empty-text="Empty Data "
        keep-source
        border
        show-overflow
        show-header-overflow
        ref="tableListOut"
        height="220"
        row-key
        highlight-hover-row
        highlight-current-row
        :row-config="{ isCurrent: true, isHover: true, height: 35 }"
        :column-config="{ resizable: true }"
        :data="selectRow.listOut"
        :mouse-config="{ selected: true }"
        :checkbox-config="{
          highlight: true,
          range: true,
        }"
        :keyboard-config="{
          isArrow: true,
          isDel: true,
          isEnter: true,
          isTab: true,
          isEdit: true,
        }"
        :edit-config="{
          trigger: 'dblclick',
          mode: 'cell',
          showStatus: true,
        }"
        :scroll-y="{ mode: 'wheel' }"
      >
        <vxe-column type="seq" fixed="left" width="60"></vxe-column>
        <vxe-column type="checkbox" width="60"></vxe-column>
        <vxe-column
          align="align"
          header-align="center"
          width="150"
          field="tglDokumen"
          :formatter="$$formatDate"
          title="BC DATE"
        >
        </vxe-column>
        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          align="align"
          header-align="center"
          width="150"
          field="idDokumen"
          title="BC DOC TYPE"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>
        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="100"
          align="center"
          header-align="center"
          field="noUrut"
          title="BC DOC NO"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>

        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="150"
          align="left"
          header-align="center"
          field="noLot"
          title="NO LOT"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>

        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="120"
          align="left"
          header-align="center"
          field="kodeBarang"
          title="CODE"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>
        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="200"
          align="left"
          header-align="center"
          field="namaBarang"
          title="DESCRIPTION"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>

        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="100"
          align="center"
          header-align="center"
          field="satuan"
          title="UNIT"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>
        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="100"
          align="center"
          header-align="center"
          field="kategori"
          title="CATEGORY"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>

        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          width="100"
          align="center"
          header-align="center"
          field="spec"
          :title="$store.state.specName"
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>

        <vxe-column
          width="150"
          align="right"
          header-align="center"
          field="qtyKeluar"
          :formatter="$$formatAmountBc"
          title="QTY OUT"
          :edit-render="{ autofocus: '.vxe-input--inner' }"
        >
          <template #edit="{ row }">
            <vxe-input
              @input="inputQtyKeluar(row)"
              v-model="row.qtyKeluar"
              size="mini"
              type="number"
            ></vxe-input>
          </template>
        </vxe-column>
      </vxe-table>

      <div class="mt-2">
        <vs-button v-on:click="submitedData" color="primary">
          Submit
        </vs-button>
        <vs-button v-on:click="$refs.nestedChildBarang.close()" color="danger">
          Close
        </vs-button>
      </div>
    </sweet-modal>
    <SelectExbc
      ref="modalExbc"
      :dataSelect="tableConfigOut.tableData"
      idCek="idAsal"
      :kodeBarang="kodeBarangCari"
      @sendData="selectedExbc"
    />
    <br />
    <vxe-modal
      v-model="modalHistory"
      title="HISTORY REQUEST"
      width="80%"
      height="60%"
      show-zoom
      resize
    >
      <template #default>
        <div class="w-full">
          <el-button type="primary" @click="historyReqHapus">Hapus</el-button>
          <TableFull
            :checkoxVisibleFunction="checkoxVisible"
            ref="tablelHistory"
            :tableConfig="tableConfigHistory"
          />
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import SelectExbc from "../../../views/components/other/SelectExbc.vue";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import TableFull from "../../components/general/TableFull.vue";
import XLSX from "xlsx";
import CustomHead from "../../components/general/CustomHead.vue";
export default {
  props: {
    test: String,
    method: {
      type: Function,
    },
  },
  components: {
    SelectExbc,
    TableFull,
    PerfectScrollbar,
    SweetModal,
    SweetModalTab,
    Datepicker,
    CustomHead,
  },
  data() {
    return {
      outByStyle: false,
      kodeBarangCari: "",
      manualExbc: false,
      filterConfig: {
        withoutDate: false,
      },
      modalHistory: false,
      dataHistory: [],
      historyoutId: null,
      tableConfigRequest: {
        bodyOverflow: true,
        headerOverflow: false,
        checkbox: false,
        select: false,
        selectTitle: "EXBC",
        tableName: "tableReq",
        tableHeight: 200,
        rowHeight: 25,
        tableData: [],
        dataFooter: ["requestQty"],
        size: "mini",
        column: [
          {
            field: "tglRequest",
            key: "tglRequest",
            title: "REQUEST DATE",
            width: 100,
            format: "date",
            align: "left",
          },
          {
            field: "noReg",
            key: "noReg",
            title: "REQUEST NUMBER",
            width: 200,
            align: "left",
          },
          {
            field: "department",
            key: "department",
            title: "DEPARTMENT",
            width: 100,
            align: "left",
          },
          {
            field: "user",
            key: "user",
            title: "USER REQUEST",
            width: 150,
            align: "left",
          },
          {
            field: "noWo",
            key: "noWo",
            title: this.$store.state.woNumberTitle,
            width: 150,
            align: "left",
          },
          {
            field: "kodeMaterial",
            key: "kodeMaterial",
            title: "MATERIAL CODE",
            width: 180,
            align: "left",
          },
          {
            field: "namaMaterial",
            key: "namaMaterial",
            title: " MATERIAL DESCRIPTION",
            width: 250,
            align: "left",
          },

          {
            field: "satuan",
            key: "satuan",
            title: "SATUAN",
            width: 100,
            align: "center",
          },
          {
            field: "requestQty",
            key: "requestQty",
            fixed: "right",
            title: "REQUEST QTY",
            width: 120,
            align: "center",
            edit: true,
            format: "price",
          },

          {
            field: "style",
            key: "style",
            title: this.$store.state.styleName,
            show: this.$store.state.availableStyle,

            width: 120,
            align: "center",
          },
          {
            field: "color",
            key: "color",
            title: this.$store.state.colorName,
            show: this.$store.state.availableColor,

            width: 120,
            align: "center",
          },
          {
            field: "size",
            key: "size",
            title: this.$store.state.sizeName,
            show: this.$store.state.availableSize,

            width: 120,
            align: "center",
          },
          {
            field: "spec",
            key: "spec",
            title: this.$store.state.specName,
            show: this.$store.state.availableSpec,

            width: 120,
            align: "center",
          },

          {
            field: "qtyOutNow",
            key: "qtyOutNow",
            fixed: "right",
            title: "QTY APPROVED",
            width: 120,
            align: "center",
            format: "price",
          },
          {
            field: "infoOut",
            key: "infoOut",
            fixed: "right",
            title: "INFO",
            width: 120,
            align: "center",
          },

          {
            field: "remark",
            key: "remark",
            title: "REMARK",
            width: 200,
            align: "left",
          },
        ],
      },

      tableConfigHistory: {
        bodyOverflow: true,
        headerOverflow: false,
        checkbox: true,
        select: false,
        tableName: "tableHistory",
        tableHeight: 200,
        rowHeight: 25,
        tableData: [],
        size: "mini",
        column: [
          {
            field: "noReg",
            key: "noReg",
            title: "NO OUT REG",
            width: 100,
            align: "left",
          },
          {
            field: "status",
            key: "status",
            title: "STATUS",
            width: 100,
            align: "left",
          },
          {
            field: "department",
            key: "department",
            title: "DEPARTMENT",
            width: 100,
            align: "left",
          },
          {
            field: "noWo",
            key: "noWo",
            title: "WO NUMBER",
            width: 100,
            align: "left",
          },
          {
            field: "tglDokumen",
            key: "tglDokumen",
            title: "BC DOC DATE",
            format: "date",
            width: 100,
            align: "left",
          },
          {
            field: "idDokumen",
            key: "idDokumen",
            title: "BC DOC TYPE",
            width: 100,
            align: "left",
          },
          {
            field: "noUrut",
            key: "noUrut",
            title: "BC DOC NO",
            width: 100,
            align: "left",
          },
          {
            field: "kodeMaterial",
            key: "kodeMaterial",
            title: "CODE",
            width: 100,
            align: "left",
          },
          {
            field: "namaMaterial",
            key: "namaMaterial",
            title: "DESCRIPTION",
            width: 100,
            align: "left",
          },
          {
            field: "satuan",
            key: "satuan",
            title: "UNIT",
            width: 100,
            align: "left",
          },
          {
            field: "qtyKeluarOk",
            key: "qtyKeluarOk",
            title: "QTY OUT",
            width: 100,
            align: "left",
          },
          {
            field: "qtyProd",
            key: "qtyProd",
            title: "QTY RECEIVING",
            width: 100,
            align: "left",
          },
          {
            field: "style",
            key: "style",
            title: "STYLE",
            width: 100,
            align: "left",
          },
          {
            field: "color",
            key: "color",
            title: "COLOR",
            width: 100,
            align: "left",
          },
          {
            field: "size",
            key: "size",
            title: "SIZE",
            width: 100,
            align: "left",
          },
          {
            field: "spec",
            key: "spec",
            title: "SPEC",
            width: 100,
            align: "left",
          },
        ],
      },
      tableConfigOut: {
        bodyOverflow: true,
        headerOverflow: false,
        checkbox: false,
        select: false,
        tableName: "tableOut",
        tableHeight: 200,
        rowHeight: 25,
        tableData: [],
        dataFooter: ["qtyKeluarOk"],
        size: "mini",
        column: [
          {
            field: "tglKeluar",
            key: "tglKeluar",
            title: "OUT DATE",
            width: 100,
            format: "date",
            align: "left",
          },
          {
            field: "noRequest",
            key: "noRequest",
            title: "REQUEST NUMBER",
            width: 200,
            align: "left",
          },
          {
            field: "department",
            key: "department",
            title: "DEPARTMENT",
            width: 100,
            align: "left",
          },
          {
            field: "userRequest",
            key: "userRequest",
            title: "USER REQUEST",
            width: 150,
            align: "left",
          },
          {
            field: "noWo",
            key: "noWo",
            title: this.$store.state.woNumberTitle,
            width: 150,
            align: "left",
          },
          {
            field: "kodeMaterial",
            key: "kodeMaterial",
            title: "MATERIAL CODE",
            width: 180,
            align: "left",
          },
          {
            field: "namaMaterial",
            key: "namaMaterial",
            title: " MATERIAL DESCRIPTION",
            width: 250,
            align: "left",
          },

          {
            field: "satuan",
            key: "satuan",
            title: "SATUAN",
            width: 100,
            align: "center",
          },

          {
            field: "style",
            key: "style",
            title: this.$store.state.styleName,
            show: this.$store.state.availableStyle,

            width: 120,
            align: "center",
          },
          {
            field: "color",
            key: "color",
            title: this.$store.state.colorName,
            show: this.$store.state.availableColor,
            width: 120,
            align: "center",
          },
          {
            field: "size",
            key: "size",
            title: this.$store.state.sizeName,
            show: this.$store.state.availableSize,
            width: 120,
            align: "center",
          },
          {
            field: "spec",
            key: "spec",
            title: this.$store.state.specName,
            show: this.$store.state.availableSpec,
            width: 120,
            align: "center",
          },

          {
            field: "qtyKeluarOk",
            key: "qtyKeluarOk",
            fixed: "right",
            title: "QTY OUT",

            width: 120,
            format: "price",
            align: "center",
          },

          {
            field: "tglDokumen",
            key: "tglDokumen",
            format: "date",
            title: "BC DOC DATE",
            width: 120,
            align: "center",
          },

          {
            field: "idDokumen",
            key: "idDokumen",
            title: "BC DOC TYPE",
            width: 120,
            align: "center",
          },

          {
            field: "noUrut",
            key: "noUrut",
            title: "BC DOC NUMBER",
            width: 120,
            align: "center",
          },
        ],
      },
      filterName1: "",
      formDataOut: {
        tglKeluar: new Date(),
        dataRequest: [],
      },
      dataAwal: [],
      checkDefault: [],
      selectRow: null,
      dataOut: [],
      dataOutAll: [],
      loadingTable: false,
      pilihanStok: "dokumen",
      dataHf: [],
      pilihHf: [],
      dataAwalRequest: [],
      save: false,
      stokorexbc: "Request",
      format: "yyyy-MM-dd",
      inipic: "",
      wodata: [],
      noSuratJalan: "",
      optionDepartment: [
        {
          text: "ADMINISTRATOR",
          value: "ADMINISTRATOR",
        },
        {
          text: "PURCHASING",
          value: "PURCHASING",
        },
        {
          text: "WAREHOUSE",
          value: "WAREHOUSE",
        },
        {
          text: "FINISH GOODS",
          value: "FINISH GOODS",
        },
        {
          text: "DELIVERY",
          value: "DELIVERY",
        },
        {
          text: "ACCOUNTING",
          value: "ACCOUNTING",
        },
        {
          text: "EXIM",
          value: "EXIM",
        },
      ],

      optionStokOrEcbc: [
        {
          text: "Request",
          value: "Request",
        },
        {
          text: "Exbc",
          value: "Exbc",
        },
      ],
      pilihMaterial: [],
      pilihDataListRequest: [],
      pilihbarangmasuk: [],
      submitted: false,
      searchQuery: "",
      dataBarangjadi: [],
      dataBarang: [],
      dataMaterial: [],
      selectBarangJadi: [],
      val: "",
      jenisPembelian: "",
      asalBarang: "",
      department: "",
      noreg: "",
      jamkeluar: "",
      bl: "",
      bc1: "",
      tglMasuk: new Date().toISOString().split("T")[0],
      reqDate: null,
      tglDokumen: null,
      tglBl: null,
      tglBc1: null,
      tglInvoice: null,
      noKontrak: "",
      noAju: "",
      noPendaftaran: "",
      noInvoice: "",
      jenisDokumen: "",
      ketOrder: "",
      tr: [],
      keterangan: "",
      status: "",
      optionKalkulasi: [],
      baca: [],
      tglAwal: new Date(),
      tglAkhir: new Date(),
      tglAwalDoc: new Date(),
      tglAkhirDoc: new Date(),
      shortcuts: this.getShortcuts(),
      listBarangMasuk: [],
      radios1: "",
      contacts2: [],
      noFaktur: "",
      search: "",
      datawo: "",
      totalKeluar: 0,
      tglKeluar: new Date().toISOString().split("T")[0],
      modalApprove: false,
      isCheckPrint: false,
      selectReq: null,
    };
  },
  watch: {
    manualExbc() {
      console.log(this.manualExbc);
      if (this.manualExbc == true) {
        this.tableConfigOut.column = [
          {
            field: "tglKeluar",
            key: "tglKeluar",
            title: "OUT DATE",
            width: 100,
            format: "date",
            align: "left",
          },
          {
            field: "noRequest",
            key: "noRequest",
            title: "REQUEST NUMBER",
            width: 200,
            align: "left",
          },
          {
            field: "department",
            key: "department",
            title: "DEPARTMENT",
            width: 100,
            align: "left",
          },
          {
            field: "userRequest",
            key: "userRequest",
            title: "USER REQUEST",
            width: 150,
            align: "left",
          },
          {
            field: "noWo",
            key: "noWo",
            title: this.$store.state.woNumberTitle,
            width: 150,
            align: "left",
          },
          {
            field: "kodeMaterial",
            key: "kodeMaterial",
            title: "MATERIAL CODE",
            width: 180,
            align: "left",
          },
          {
            field: "namaMaterial",
            key: "namaMaterial",
            title: " MATERIAL DESCRIPTION",
            width: 250,
            align: "left",
          },

          {
            field: "satuan",
            key: "satuan",
            title: "SATUAN",
            width: 100,
            align: "center",
          },

          {
            field: "style",
            key: "style",
            title: this.$store.state.styleName,
            show: this.$store.state.availableStyle,

            width: 120,
            align: "center",
          },
          {
            field: "color",
            key: "color",
            title: this.$store.state.colorName,
            show: this.$store.state.availableColor,
            width: 120,
            align: "center",
          },
          {
            field: "size",
            key: "size",
            title: this.$store.state.sizeName,
            show: this.$store.state.availableSize,
            width: 120,
            align: "center",
          },
          {
            field: "spec",
            key: "spec",
            title: this.$store.state.specName,
            show: this.$store.state.availableSpec,
            width: 120,
            align: "center",
          },

          {
            field: "qtyKeluarOk",
            key: "qtyKeluarOk",
            fixed: "right",
            title: "QTY OUT",
            edit: true,
            width: 120,
            format: "price",
            align: "center",
          },

          {
            field: "tglDokumen",
            key: "tglDokumen",
            format: "date",
            title: "BC DOC DATE",
            width: 120,
            align: "center",
          },

          {
            field: "idDokumen",
            key: "idDokumen",
            title: "BC DOC TYPE",
            width: 120,
            align: "center",
          },

          {
            field: "noUrut",
            key: "noUrut",
            title: "BC DOC NUMBER",
            width: 120,
            align: "center",
          },
        ];
      } else {
        this.tableConfigOut.column = [
          {
            field: "tglKeluar",
            key: "tglKeluar",
            title: "OUT DATE",
            width: 100,
            format: "date",
            align: "left",
          },
          {
            field: "noRequest",
            key: "noRequest",
            title: "REQUEST NUMBER",
            width: 200,
            align: "left",
          },
          {
            field: "department",
            key: "department",
            title: "DEPARTMENT",
            width: 100,
            align: "left",
          },
          {
            field: "userRequest",
            key: "userRequest",
            title: "USER REQUEST",
            width: 150,
            align: "left",
          },
          {
            field: "noWo",
            key: "noWo",
            title: this.$store.state.woNumberTitle,
            width: 150,
            align: "left",
          },
          {
            field: "kodeMaterial",
            key: "kodeMaterial",
            title: "MATERIAL CODE",
            width: 180,
            align: "left",
          },
          {
            field: "namaMaterial",
            key: "namaMaterial",
            title: " MATERIAL DESCRIPTION",
            width: 250,
            align: "left",
          },

          {
            field: "satuan",
            key: "satuan",
            title: "SATUAN",
            width: 100,
            align: "center",
          },

          {
            field: "style",
            key: "style",
            title: this.$store.state.styleName,
            show: this.$store.state.availableStyle,

            width: 120,
            align: "center",
          },
          {
            field: "color",
            key: "color",
            title: this.$store.state.colorName,
            show: this.$store.state.availableColor,
            width: 120,
            align: "center",
          },
          {
            field: "size",
            key: "size",
            title: this.$store.state.sizeName,
            show: this.$store.state.availableSize,
            width: 120,
            align: "center",
          },
          {
            field: "spec",
            key: "spec",
            title: this.$store.state.specName,
            show: this.$store.state.availableSpec,
            width: 120,
            align: "center",
          },

          {
            field: "qtyKeluarOk",
            key: "qtyKeluarOk",
            fixed: "right",
            title: "QTY OUT",

            width: 120,
            format: "price",
            align: "center",
          },

          {
            field: "tglDokumen",
            key: "tglDokumen",
            format: "date",
            title: "BC DOC DATE",
            width: 120,
            align: "center",
          },

          {
            field: "idDokumen",
            key: "idDokumen",
            title: "BC DOC TYPE",
            width: 120,
            align: "center",
          },

          {
            field: "noUrut",
            key: "noUrut",
            title: "BC DOC NUMBER",
            width: 120,
            align: "center",
          },
        ];
      }
    },
  },
  computed: {
    validName() {
      return (
        this.valMultipe.kategori.length > 0 && this.valMultipe.jenis.length > 0
      );
    },
  },
  methods: {
    historyReqHapus() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("delete"),
        text: this.$t("yakinHapusData"),
        accept: async () => {
          try {
            const selected = this.$refs.tablelHistory.selectedCheckbox();
            this.$api.post("api/v1/warehouse/materialout/deleteall", selected);
            const data = await this.getHistoryout();
            this.tableConfigHistory.tableData = data;
          } catch (error) {
            console.log(error);
            this.notifError("TERJADI ERROR", true);
          }
        },
      });
    },
    checkoxVisible(row) {
      if (row.qtyProd > 0) {
        return false;
      } else {
        return true;
      }
    },
    async getHistoryout() {
      const res = await this.$api.get(
        this.$serviceApi + "warehouse/historyout",
        { params: { idRequest: this.historyout } }
      );
      return res.data.content;
    },
    async checkStatusReq() {
      const res = await this.$api.get("api/v1/request/checkstatus", {
        params: { id: this.historyout },
      });
      console.log(res.data);
      let finds = this.dataBarangjadi.find((f) => f.id == this.historyout);
      if (finds) {
        finds.qtyOut = res.data.content.qtyOut;
      }
    },
    async handleCellClick({ row, column }) {
      if (column.field == "qtyOut") {
        this.historyout = row.id;
        await this.checkStatusReq();
        const data = await this.getHistoryout();
        this.modalHistory = true;
        this.tableConfigHistory.tableData = data;
      }
    },
    selectedExbc(row) {
      let cek = this.tableConfigOut.tableData.some((s) => s.idAsal == row.id);
      if (cek) {
        this.notifValidasi("Data Sudah terpilih", true);
        return;
      }

      let qtyKeluar = row.qtyInputWh - (row.qtyOutWh || 0);
      if (qtyKeluar >= this.selectReq.requestQty) {
        qtyKeluar = this.selectReq.requestQty;
      }
      let newElm = {
        kodeBarang: this.selectReq.kodeBarang,
        kodeMaterial: row.kodeBarang,
        namaMaterial: this.selectReq.namaMaterial,
        typeMaterial: this.selectReq.typeMaterial,
        style: this.selectReq.style,
        color: this.selectReq.color,
        size: this.selectReq.size,
        spec: this.selectReq.spec,
        noRegWo: this.selectReq.noRegWo,
        noWo: this.selectReq.noWo,

        department: this.selectReq.department,

        bcAsal: row.idDokumen,

        noBc: row.noUrut,
        tglBc: row.tglDokumen,
        idAsal: row.id,

        tglDokumen: row.tglDokumen,
        idDokumen: row.idDokumen,
        noUrut: row.noUrut,

        qtyKeluar: qtyKeluar,
        satuan: row.satuanInputWh,

        qtyKeluarOk: qtyKeluar,
        satuanKeluarOk: row.satuanInputWh,

        isHabis: false,
        idRequest: this.selectReq.id,
        noRequest: this.selectReq.noReg,
        tglKeluar: this.formDataOut.tglKeluar,

        userRequest: this.selectReq.user,
      };
      this.tableConfigOut.tableData.push(newElm);
      this.notifikasiCustom("success", "Berhasil", "Pilih data");
    },
    cariExbc(row) {
      this.selectReq = row;

      this.$refs.modalExbc.openModal(row.kodeMaterial);
    },
    printOutCheck() {
      this.isCheckPrint = !this.isCheckPrint;
      if (this.isCheckPrint == true) {
        this.notifikasiCustom(
          "info",
          "Silahkan",
          "Pilih data untuk di print, lalu klik tombol print kembali"
        );
      }
      if (this.isCheckPrint == false) {
        this.printOut();
      }
    },
    async printOut() {
      let select = this.$refs.xTable.getCheckboxRecords();
      select = select.filter((f) => f.qtyOut > 0);

      if (select.length <= 0) {
        return this.notifValidasi(
          "Silahkan pilih request yang sudah di approve",
          true
        );
      }
      let get = await this.$api.post("api/v1/request/findallout", select);
      let data = [];
      get.data.content.forEach((elm) => {
        data = [...data, ...elm.listOut];
      });
      if (data.length <= 0) {
        return this.notifValidasi("Data tidak ada yang sudah di out", true);
      }
      this.$router.push({
        name: "printmaterialout",
        params: { id: data },
      });
    },
    rowStyleRequest(row) {
      if (row.infoOut == "INFO") {
        return;
      }

      if (row.notValidOut == true) {
        return {
          backgroundColor: "red",
          color: "white",
        };
      }
      if (row.qtyOutNow < row.requestQty) {
        return {
          backgroundColor: "yellow",
        };
      }
    },
    saveToLocalStorageOut(val) {
      console.log(val);
      localStorage.setItem("outByStyle", JSON.stringify(val));
    },
    exportExcel() {
      const tglAwal = moment(this.tglAwal).format("yyyy-MM-DD");
      const tglAkhir = moment(this.tglAkhir).format("yyyy-MM-DD");
      let headers = [
        {
          title: this.$t("tanggal").toUpperCase(),
          field: "tglRequest",
          format: "date",
        },
        { title: this.$t("noRegi").toUpperCase(), field: "noReg" },
        { title: this.$t("dept").toUpperCase(), field: "department" },
        { title: this.$t("user").toUpperCase(), field: "user" },
        { title: this.$t("noPo").toUpperCase(), field: "noWo" },
        { title: this.$t("code").toUpperCase(), field: "kodeMaterial" },
        { title: this.$t("deskripsi").toUpperCase(), field: "namaMaterial" },
        { title: this.$t("satuan").toUpperCase(), field: "satuan" },
        { title: this.$t("qtyRequest").toUpperCase(), field: "qty" },
        { title: this.$t("qtyOut").toUpperCase(), field: "qtyOut" },
        { title: this.$store.state.styleName, field: "style" },
        { title: this.$store.state.colorName, field: "color" },
        { title: this.$store.state.sizeName, field: "size" },
        { title: this.$store.state.specName, field: "spec" },
      ];
      headers = headers
        .map((v) => {
          if (!this.$store.state.availableStyle && v.field === "style") {
            return;
          }
          if (!this.$store.state.availableColor && v.field === "color") {
            return;
          }
          if (!this.$store.state.availableSize && v.field === "size") {
            return;
          }
          if (!this.$store.state.availableSpec && v.field === "spec") {
            return;
          }
          return v;
        })
        .filter((x) => x);
      let { hasilHeader: hasilHeader, hasilData: hasilData } =
        this.$$susunDataExport(headers, this.dataBarangjadi);

      let resultExtract = [hasilHeader, ...hasilData];
      let data = XLSX.utils.aoa_to_sheet(resultExtract);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");

      switch (this.$store.state.userLang) {
        case "id":
          XLSX.writeFile(
            wb,
            `WAREHOUSE MATERIAL KELUAR LIST PERMINTAAN ${this.$store.state.companyName} PRIODE ${tglAwal}/${tglAkhir}.xlsx`
          );

          break;
        case "en":
          XLSX.writeFile(
            wb,
            `WAREHOUSE MATERIALOUT REQUEST LIST ${this.$store.state.companyName} PRIODE ${tglAwal}/${tglAkhir}.xlsx`
          );
          break;
        default:
          XLSX.writeFile(
            wb,
            `WAREHOUSE MATERIALOUT KELUAR LIST PERMINTAAN ${this.$store.state.companyName} PRIODE ${tglAwal}/${tglAkhir}.xlsx`
          );
      }
    },
    footerMethod({ columns, data }) {
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 0) {
            return "TOTAL";
          }
          if (["sisaRequest", "qtyOut", "qty"].includes(column.property)) {
            return this.$formatAmountBc(this.$$sumNum(data, column.property));
          }
          return null;
        }),
      ];
      return footerData;
    },
    checkMethod({ row }) {
      if (this.isCheckPrint == true) {
        return true;
      }

      if (row.isComplete) {
        return false;
      }
      if (row.qtyOut == row.qty) {
        return false;
      }
      return true;
    },
    resetOut() {
      this.tableConfigOut.tableData = [];
      this.tableConfigRequest.tableData.forEach((elm) => {
        elm.infoOut = "INFO";
        elm.qtyOutNow = 0;
      });
    },
    async saveApprove() {
      let data = this.tableConfigOut.tableData;
      if (data.length <= 0) {
        return this.notifValidasi("Silahkan Pilh & Approvr Data", true);
      }

      this.loadingWait();
      // let dataOut = {dataOut: data, tglKeluar: this.tglKeluar, }
      // let post = await this.$api.post(this.$serviceApi+
      //   "warehouse/postoutnew",
      //   dataOut,
      // );
      let post = await this.$api.post(
        "api/v1/warehouse/materialout/postall",
        data,
        {
          params: {
            tglKeluar: this.$formatDatemoment(this.formDataOut.tglKeluar),
          },
        }
      );
      if (post.data.status == "validation") {
        this.loadingStop();
        return this.notifValidasi(post.data.message, true);
      }
      this.notifikasiCustom("success", "BERHASIL", "SAVE MATERIAL OUT");
      this.modalApprove = false;
      this.getDataRequest();
      this.resetOut();
      this.loadingStop();
    },
    async approveAllSelected() {
      try {
        this.resetOut();
        this.loadingWait();
        this.tableConfigRequest.tableData.forEach((elm) => {
          elm.sisaRequest = parseFloat(elm.sisaRequest);
          elm.requestQty = parseFloat(elm.requestQty);
          elm.qty = parseFloat(elm.requestQty);
          elm.requestQty = parseFloat(elm.requestQty);
          elm.sisaRequest = parseFloat(elm.sisaRequest);
        });

        let params = {
          tglKeluar: this.$formatDatemoment(this.formDataOut.tglKeluar),
          outByStyle: this.outByStyle ? "y" : null,
        };

        let post = await this.$api.post(
          "api/v1/warehouse/materialout/getfifo",
          this.tableConfigRequest.tableData,
          { params }
        );

        if (post.data.status == "validation") {
          this.loadingStop();
          return this.notifValidasi(post.data.message, true);
        }
        this.tableConfigOut.tableData = post.data.dataOut;
        post.data.dataRequest.forEach((elm, i) => {
          this.tableConfigRequest.tableData[i].infoOut = "";
          this.tableConfigRequest.tableData[i].infoOut = elm.infoOut;
          this.tableConfigRequest.tableData[i].qtyOutNow = elm.qtyOut;
          this.tableConfigRequest.tableData[i].notValidOut = elm.notValidOut;
        });

        this.$refs.tableRequest.reloadData();

        this.notifikasiCustom(
          "success",
          "BERHASIL",
          "Approve Material, Silahkan Simpan Untuk Konfirmasi"
        );
        this.loadingStop();
      } catch (error) {
        console.log(error);
        this.loadingStop();
        this.notifError("Silahkan Hubungi INSYS, ADA SESUATU", true);
      }
    },
    goApprove(type) {
      let select = this.$refs.xTable.getCheckboxRecords();
      if (select.length <= 0)
        return this.notifValidasi(this.$t("silahkanPilihData"), true);
      select.map((m) => {
        m.infoOut = "";
        if (!m.qtyOut) {
          m.qtyOut = 0;
        }
        m.requestQty = m.qty - m.qtyOut;
        return m;
      });

      this.tableConfigRequest.tableData = select;
      this.resetOut();

      if (type == "manual") {
        this.manualExbc = true;
        this.tableConfigRequest.select = true;
      } else {
        this.tableConfigRequest.select = false;
        this.manualExbc = false;
      }
      this.modalApprove = true;
    },
    handleClickTab(tab) {
      if (tab.label == "OUT LIST") {
        this.listBarangMasuk = [];

        this.baca.forEach((elm) => {
          elm.listOut.forEach((elc) => {
            let newElm = { ...elc };
            delete newElm._X_ROW_KEY;
            newElm.orderNumber = elm.orderNumber;

            this.listBarangMasuk.push(newElm);
          });
        });
      }
    },
    inputQtyKeluar(row) {
      if (parseFloat(row.qtyKeluar) > parseFloat(row.qtyKeluarAwal)) {
        row.qtyKeluar = parseFloat(row.qtyKeluarAwal);
        this.$vs.notify({
          title: this.$t("gagal"),
          text: "Tidak Bisa Melebihi Batas",
          color: "danger",
        });
      }

      let totKel = this.$formatAngka(
        this.selectRow.listOut.reduce((acc, cur) => {
          return parseFloat(acc) + parseFloat(cur.qtyKeluar);
        }, 0)
      );
      this.totalKeluar = totKel;
    },
    selectOut({ records }) {
      let newData = [];
      this.selectRow.listOut.forEach((elm) => {
        let cek = records.some((s) => s.od == elm.idAsal);
        if (cek) {
          newData.push(elm);
        }
      });

      this.selectRow.listOut = newData;
      let totKel = this.$formatAngka(
        this.selectRow.listOut.reduce((acc, cur) => {
          return parseFloat(acc) + parseFloat(cur.qtyKeluar);
        }, 0)
      );
      this.totalKeluar = totKel;

      records.forEach((el) => {
        let cek = newData.some((s) => s.idAsal == el.id);
        if (!cek) {
          let newElm = { ...el };
          newElm.idAsal = el.id;
          newElm.idRequest = this.selectRow.id;
          let availQty = el.qty - el.qtyOut;
          let tmpQty = this.selectRow.balance - this.totalKeluar;
          newElm.qtyKeluar = availQty >= tmpQty ? tmpQty : availQty;
          newElm.qtyKeluarAwal = newElm.qtyKeluar;

          delete newElm.id;
          if (newElm.qtyKeluar > 0) {
            this.selectRow.listOut.push(newElm);
          } else {
            this.$refs.tableOut.setCheckboxRow(el, false);
          }
        }
        let totKel = this.$formatAngka(
          this.selectRow.listOut.reduce((acc, cur) => {
            return parseFloat(acc) + parseFloat(cur.qtyKeluar);
          }, 0)
        );
        this.totalKeluar = totKel;
      });
      this.$refs.tableListOut.reloadData(this.selectRow.listOut);
    },
    async getOut(row) {
      row.balance = row.qty - row.qtyOut;
      row.totalKeluar = 0;

      row.listOut = [];
      this.selectRow = row;

      this.dataOut = [];
      this.dataOutAll = [];
      this.$refs.tableOut.clearCheckboxRow();
      //periksa dulu data Outnya apakah ada kode material tersebut

      let tglawal = moment(this.tglAwalDoc).format("yyyy-MM-DD");
      let tglakhir = moment(this.tglAkhirDoc).format("yyyy-MM-DD");
      let get = await this.$api.get("api/v1/warehouse/barangmasuk/notequals", {
        params: { kodeBarang: row.kodeMaterial, start: tglawal, end: tglakhir },
      });
      let concat = this.dataOutAll.concat(get.data.content);
      this.dataOutAll = concat;
      this.dataOut = this.dataOutAll.filter(
        (f) => f.kodeBarang == row.kodeMaterial
      );

      this.$refs.nestedChildBarang.open();
    },
    back() {
      this.$router.push("/warehouse/materialout");
    },

    async submitedData() {
      if (this.getBannedValue(this.selectRow)) {
        this.$vs.notify({
          color: "danger",
          title: "VALIDATION",
          text: "Please Select Data",
        });
        return;
      }
      if (
        this.getBannedValue(this.selectRow.listOut) ||
        this.selectRow.listOut.length <= 0
      ) {
        this.$vs.notify({
          color: "danger",
          title: "VALIDATION",
          text: "Please Select Data",
        });
        return;
      }
      this.$vs.loading({ text: "Mohon tunggu, Sedang melakukan simpan data " });
      try {
        this.save = true;
        let dataPost = [];
        for (const el0 of this.selectRow.listOut) {
          let post = {
            idAsal: el0.idAsal,
            noReg: this.noreg,
            noWo: this.selectRow.noWo,
            namaMaterial: el0.namaBarang,
            kodeMaterial: el0.kodeBarang,
            typeMaterial: el0.tipeBarang,
            spec: el0.spec,
            kategori: el0.kategori,
            color: el0.color,

            noLot: el0.noLot,
            noRequest: el0.noRequest,
            tglBc: new Date(el0.tglDokumen),
            qtyKeluar: el0.qtyKeluar,
            qtyProd: 0,
            bcAsal: el0.idDokumen,
            jenis: el0.jenis,
            noBc: el0.noUrut,
            department: this.selectRow.department,
            idRequest: el0.idRequest,
            approveStatus: "Waiting for Received",
            satuan: el0.satuan,
            style: el0.style,
            size: el0.size,
            isDeleted: false,
            noUrut: el0.noUrut,
            idDokumen: el0.idDokumen,
            isApprove: false,
            isUse: false,
            user: this.$store.state.userEmail,
          };
          dataPost.push(post);
        }

        await this.$api.post("/api/v1/warehouse/materialout/postall", dataPost);
        this.totalKeluar = 0;

        setTimeout(() => {
          this.$vs.loading.close();
          this.$refs.nestedChildBarang.close();
          this.acceptAlert();
          this.getDataRequest();
          return;
        }, 800);
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.loading({ text: "error: Hubungi developer" });
        console.log(error);
      }
    },

    acceptAlert() {
      this.$vs.notify({
        color: "success",
        title: this.$t("berhasil"),
        text: "Berhasil Mengeluarkan Barang",
      });
    },
    close() {
      this.clearValMultiple();
      this.$vs.notify({
        color: "danger",
        title: this.$t("gagal"),
        text: "Batal Mengeluarkan Barang!",
      });
    },
    clearValMultiple() {
      this.valMultipe.kodeBarang = "";
      this.valMultipe.namaBarang = "";
      this.valMultipe.kategori = "";
      this.valMultipe.jenis = "";
    },
    compareValues(key, order = "asc") {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          // property doesn't exist on either object
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    },

    async changeFilter({ filterList }) {
      if (filterList.length == 0) {
        this.getDataRequest();
        return;
      }

      this.getDataRequest(filterList);
    },
    async getDataRequest(filterList) {
      if (!filterList) filterList = [];
      let dataSearch = {};
      for (let elm of filterList) {
        dataSearch[elm.field] = elm.datas[0];
      }

      if (!this.filterConfig.withoutDate) {
        let tglawal = moment(this.tglAwal).format("yyyy-MM-DD");
        let tglakhir = moment(this.tglAkhir).format("yyyy-MM-DD");
        dataSearch.tglAwal = tglawal;
        dataSearch.tglAkhir = tglakhir;
      }

      dataSearch.companyCode = this.$store.state.companyCode;
      let get = await this.$api.get(this.$serviceApi + "request/notequalswh", {
        params: dataSearch,
      });
      get.data.content.forEach((elm) => {
        elm.sisaRequest = elm.qty - elm.qtyOut;
      });
      this.dataBarangjadi = get.data.content;
      this.statusSusun();
    },
    statusSusun() {
      this.dataBarangjadi.forEach((elm) => {
        if (elm.qtyOut <= 0 && !elm.isComplete) {
          elm.approveStatus = "Belum Terpenuhi";
        }
        if (elm.qtyOut > 0 && !elm.isComplete) {
          elm.approveStatus = "Separuh Terpenuhi";
        }
        if (elm.qtyOut > 0 && elm.isComplete) {
          elm.approveStatus = "Terpenuhi";
        }
      });

      this.dataBarangjadi = this.dataBarangjadi.sort((a, b) => {
        if (this.$store.state.userLang == "id") {
          return a.approveStatus.localeCompare(b.approveStatus);
        } else {
          return b.approveStatus.localeCompare(a.approveStatus);
        }
      });
    },
    cekTanggal() {
      if (this.tglAwal > this.tglAkhir) {
        this.tglAwal = this.tglAkhir;
        this.$vs.notify({
          text: this.$t("silahkanPilihTanggalYangSesuai"),
          color: "warning",
        });
      } else {
        this.getDataRequest();
      }
    },
    cekTanggalDoc() {
      if (this.tglAwalDoc > this.tglAkhirDoc) {
        this.tglAwalDoc = this.tglAkhirDoc;
        this.$vs.notify({
          text: this.$t("silahkanPilihTanggalYangSesuai"),
          color: "warning",
        });
      } else {
        this.getOut(this.selectRow);
      }
    },
  },

  async mounted() {
    this.outByStyle = JSON.parse(localStorage.getItem("outByStyle"));
    console.log(JSON.parse(localStorage.getItem("outByStyle")));

    var date = new Date();

    this.tglAkhir = new Date();

    date.setDate(date.getDate() - 1);

    this.tglAwal = date;
    this.tglAwalDoc = date;

    this.getDataRequest();

    var year = date.getFullYear();
    // console.log(year);
    var month = (date.getMonth() + 1).toString().padStart(2, "0");
    var day = date.getDate().toString().padStart(2, "0");
    var hour = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();

    var seedatetime =
      "OUT-" + year + month + day + "-" + hour + minutes + seconds;

    this.noreg = seedatetime;
    this.jamkeluar = hour + ":" + minutes + ":" + seconds;
    // this.reqDate = moment(new Date());
    // this.tglKeluar = date;
    // let abc = date.setDate(date.getDate() + 7);
    // this.$refs.modal.open();
    // console.log("tgl,", this.tglKeluar);

    // this.wasSidebarOpen = this.$store.state.reduceButton;
    //
  },
};
</script>
